// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fcopilot-licensing.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { CopilotLicenseType } from '../../copilot-licensing';
import { CheckCopilotLicenseSignalBase } from '../copilot-licensing.g';
import { schemaObjectHeaderValidatorInstance, schemaObjectValidatorInstance } from '../../generated/validator/schema-object-validator.g';
import { validateArray } from '@augloop/validator-common';
export class CopilotAugloopIdentityBaseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'CopilotAugloopIdentityBase: Expected object, got undefined object for CopilotAugloopIdentityBaseValidator' };
        }
        if (obj.licenseType === undefined) {
            return { success: false, error: 'CopilotAugloopIdentityBase: Required field "licenseType" is missing' };
        }
        else {
            const result = copilotLicenseTypeValidatorInstance.validate(obj.licenseType);
            if (!result.success) {
                result.error = "CopilotAugloopIdentityBase.licenseType: " + result.error;
                return result;
            }
        }
        if (obj.identityToken === undefined) {
            return { success: false, error: 'CopilotAugloopIdentityBase: Required field "identityToken" is missing' };
        }
        else if (typeof obj.identityToken !== 'string') {
            return { success: false, error: 'CopilotAugloopIdentityBase: Required field "identityToken" is wrong type' };
        }
        return { success: true };
    }
}
export const copilotAugloopIdentityBaseValidatorInstance = new CopilotAugloopIdentityBaseValidator();
export class CheckCopilotLicenseSignalBaseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'CheckCopilotLicenseSignalBase: Expected object, got undefined object for CheckCopilotLicenseSignalBaseValidator' };
        }
        if (obj.augLoopTokenIdentities !== undefined) {
            const result = validateArray(obj.augLoopTokenIdentities, 1, copilotAugloopIdentityBaseValidatorInstance, '{CopilotAugloopIdentityBase}');
            if (!result.success) {
                result.error = "CheckCopilotLicenseSignalBase.augLoopTokenIdentities: " + result.error;
                return result;
            }
        }
        if ((obj.targetObject !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.targetObject);
            if (!result.success) {
                result.error = "CheckCopilotLicenseSignalBase.targetObject: " + result.error;
                return result;
            }
        }
        if ((obj.timestamp !== undefined) && (typeof obj.timestamp !== 'number')) {
            return { success: false, error: 'CheckCopilotLicenseSignalBase: Optional field "timestamp" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!CheckCopilotLicenseSignalBase.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "CheckCopilotLicenseSignalBase"' };
        }
        return { success: true };
    }
}
export const checkCopilotLicenseSignalBaseValidatorInstance = new CheckCopilotLicenseSignalBaseValidator();
export class CopilotLicenseTypeValidator {
    validate(value) {
        if (!CopilotLicenseTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "CopilotLicenseType"' };
        }
        return { success: true };
    }
}
CopilotLicenseTypeValidator.validValues = new Set([CopilotLicenseType.Unknown, CopilotLicenseType.CopilotInM365, CopilotLicenseType.CopilotPro, CopilotLicenseType.CopilotEnterprise]);
export const copilotLicenseTypeValidatorInstance = new CopilotLicenseTypeValidator();
//# sourceMappingURL=copilot-licensing-validator.g.js.map